import { Chip } from "@mui/material";
import { Icons, Ptag } from "components/core";
import React, { useEffect, useState } from "react";
import { colors } from "theme";
import styled from "styled-components";
import Link from "@mui/material/Link";
import { DisplayName } from "utlis/utils";
import { useNavigate } from "react-router";
import routes from "components/routes";
import http from "services/httpService";
import VerifiedIcon from '@mui/icons-material/DoneRounded';

function PlansetupButton({ flex, details, userplan, isAddProductFlow, products, wellnessSetupState }) {
  console.log({products, details})
  const navigate = useNavigate();
  const [productName, setProductName] = useState("");
  const [isUploadPending, setUploadPending] = useState(false);

  useEffect(() => {
    let upload_flag = details.setup_completed; //based on this we should show edit and remove <button></button>
    if(wellnessSetupState && details?.product_type?.product_type_name === "wellness") {
      upload_flag = true
    }
    console.log({upload_flag, wellnessSetupState})
    const product_name = DisplayName(details?.product_type?.display_name);
    setProductName(product_name);
    setUploadPending(upload_flag);
  }, [details.setup_completed, details?.product_type?.product_type_name, details?.product_type?.display_name, wellnessSetupState]);

  const redirectionToSetupflow = (existing) => {
    if(isAddProductFlow && existing) return;
    localStorage.setItem("eb_current_plan", userplan);
    if(details?.product_type?.product_type_name === "wellness") {
      navigate(`/wellness`);
      return;
    }
    navigate(`/${routes.UNIVERSAL_INSURER_SETUP}`);
  };
  const removeProduct = async (e) => {
    e.stopPropagation();
    const payload = {
      userplan_id: userplan,
    };
    try {
      const resp = await http.post("/business/delete_userplan/", payload);
      window.location.reload();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {isUploadPending ? (
        <ProductSetup
          bgColor="#E4DCFE"
          border="0px"
          onClick={() => redirectionToSetupflow(true)}
        >
          <RowAlignCenter>
            <Ptag fontSize="14px" fontWeight="500" marginLeft="16px">
              {productName}
            </Ptag>
            {flex && (
              <Chip
                label={`${details.mandatory ? "Mandatory" : "Voluntary"}`}
                color="primary"
                sx={{
                  fontSize: "14px",
                  padding: "0.5rem",
                  marginLeft: "10px",
                  fontFamily: "Inter",
                  backgroundColor: colors.primaryColor,
                  color: colors.whiteColor,
                  borderRadius: "999px",
                  cursor: "pointer"
                }}
              />
            )}
            <VerifiedIcon style={{
              fontSize: "26px",
              marginLeft: "8px",
              color: colors.primaryColor
            }} />
          </RowAlignCenter>
          {!isAddProductFlow && <RowAlignCenter gap="2rem" marginRight="1rem">
            <Link
              component="button"
              variant="body2"
              style={{
                fontSize: "14px",
                color: colors.primaryColor,
                textDecoration: "underline",
              }}
            >
              Edit
            </Link>
            <Link
              component="button"
              variant="body2"
              onClick={removeProduct}
              style={{
                fontSize: "14px",
                color: colors.primaryColor,
                textDecoration: "underline",
              }}
            >
              Remove
            </Link>
          </RowAlignCenter>}
        </ProductSetup>
      ) : (
        <ProductSetup onClick={() => redirectionToSetupflow()}>
          <RowAlignCenter>
            <Ptag fontSize="14px" fontWeight="500" marginLeft="14px">
              {productName}
            </Ptag>
            {flex && (
              <Chip
                label={`${details.mandatory ? "Mandatory" : "Voluntary"}`}
                color="primary"
                sx={{
                  fontSize: "14px",
                  padding: "0.5rem",
                  marginLeft: "1rem",
                  fontFamily: "Inter",
                  fontWeight: "500",
                  backgroundColor: colors.cardBackgroundColor,
                  color: colors.primaryColor,
                  borderRadius: "8px",
                  cursor: "pointer"
                }}
              />
            )}
          </RowAlignCenter>
          <div style={{
            display: "flex",
            alignItems: "center",
            gap: "1rem",
          }}>
            {products.length > 1 ?<Link
                component="button"
                variant="body2"
                onClick={removeProduct}
                style={{
                  fontSize: "14px",
                  color: colors.primaryColor,
                  textDecoration: "underline",
                }}
              >
                Remove
              </Link> : null}
            <Icons icon={"chevron_right"} />
          </div>
        </ProductSetup>
      )}
    </>
  );
}

export default PlansetupButton;

const RowAlignCenter = styled.div`
  display: flex;
  flex: row;
  gap: ${(props) => (props.gap ? props.gap : "0.5rem")};
  align-items: center;
  margin-right: ${(props) => (props.marginRight ? props.marginRight : "")};
`;

const ProductSetup = styled.section`
  background: ${(props) => (props.bgColor ? props.bgColor : "white")};
  border: ${(props) =>
    props.border ? props.border : `1px solid ${colors.primaryColor}`};
  align-items: center;
  padding: 1.8rem 1.2rem;
  border-radius: 10px;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  user-select: none;
  cursor: pointer;
  transition: 0.2s all ease-in-out;
`;
